import { Typography, theme } from "antd";
import type React from "react";
import { Link } from "react-router-dom";
import { DefaultButton } from "./DefaultButton";

const { useToken } = theme;

type Props = {
  to: string;
  btnText: string;
};

export const BackToButton: React.FC<Props> = ({ to, btnText }) => {
  const { token } = useToken();

  return (
    <Link to={to}>
      <DefaultButton
        type="text"
        icon={<i style={{ color: token.colorTextSecondary }} className="fa-solid fa-angle-left"></i>}
      >
        <Typography.Text type="secondary" strong>
          {btnText}
        </Typography.Text>
      </DefaultButton>
    </Link>
  );
};
